<h2 mat-dialog-title class="modal-add-header"><mat-icon class="with-text" color="white">add</mat-icon>เพิ่มผู้ดูแลระบบ</h2>
<form [formGroup]="fg" (ngSubmit)="onSubmit()" #form>
  <mat-dialog-content>
    <mat-form-field>
      <mat-label>ชื่อผู้ดูแลระบบ</mat-label>
      <input matInput formControlName="name" placeholder="ชื่อผู้ดูแลระบบ">
      <mat-error *ngIf="fg.get('name').getError('required')">{{ _e.addUserRequiredName }}</mat-error>
    </mat-form-field>
    <br>
    <mat-form-field>
      <mat-label>อีเมลล์</mat-label>
      <input matInput formControlName="email" placeholder="อีเมลล์">
      <mat-error *ngIf="fg.get('email').getError('required')">{{ _e.addUserRequiredEmail }}</mat-error>
      <mat-error *ngIf="fg.get('email').getError('email')">{{ _e.addUserFormatEmail }}</mat-error>
      <mat-error *ngIf="fg.get('email').getError('existed')">{{ _e.addUserEmailExisted }}</mat-error>
      <mat-error *ngIf="fg.get('email').getError('invalidEmail')">{{ _e.addUserFormatEmail }}</mat-error>
    </mat-form-field>
    <br>
    <mat-form-field>
      <mat-label>เบอร์โทรศัพท์</mat-label>
      <input matInput formControlName="phoneNumber" placeholder="เบอร์โทรศัพท์">
      <mat-error *ngIf="fg.get('phoneNumber').getError('required')">{{ _e.addUserRequiredPhone }}</mat-error>
    </mat-form-field>
    <br>
    <div formGroupName="pwd">
    <mat-form-field>
      <mat-label>รหัสผ่าน</mat-label>
      <input type="password" formControlName="password" matInput placeholder="รหัสผ่าน">
      <mat-error *ngIf="pFG.get('password').getError('required')">{{ _e.addUserRequiredPassword }}</mat-error>
      <mat-error *ngIf="pFG.get('password').getError('minlength')">{{ _e.addUserPasswordLength }}</mat-error>
    </mat-form-field>
    <mat-form-field>
      <mat-label>รหัสผ่านอีกครั้ง</mat-label>
      <input 
          type="password" formControlName="confirmPassword" 
          matInput placeholder="รหัสผ่านอีกครั้ง" [errorStateMatcher]="passwordMatcher">
          <mat-error *ngIf="pFG.get('confirmPassword').getError('required')">{{ _e.addUserRequiredPassword }}</mat-error>    
          <mat-error *ngIf="pFG.hasError('identity') && pFG.get('confirmPassword').valid">{{ _e.addUserPasswordConfirm }}</mat-error>
    </mat-form-field>
  </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <div class="flex-spacer"></div>
    <button mat-raised-button mat-dialog-close type="button" [mat-dialog-close]="false">ยกเลิก</button>
    <!-- The mat-dialog-close directive optionally accepts a value as a result for the dialog. -->
    <button mat-raised-button class="submit-button">บันทึก</button>
  </mat-dialog-actions>
</form>
